"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chain = chain;
function* chain(...iterables) {
    for (const iterable of iterables) {
        yield* iterable;
    }
}
//# sourceMappingURL=chain.js.map